export { default } from "./CurricQuote";
